exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-1f9327ae]{\n  list-style: circle;\n}\nol[data-v-1f9327ae]{\n  list-style: decimal;\n}\n", ""]);

// exports
